module.exports = __webpack_public_path__ + "img/mockup-mobile-1.98e68fcf.jpg";